var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlvinho(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48A1AF"
    },
    d: "M248.1,0C111.1,0,0,111.1,0,248.1s111.1,248.1,248.1,248.1s248.1-111.1,248.1-248.1S385.1,0,248.1,0z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D1D1E"
    },
    d: "M418.5,382.8c-8.5-27.3-81.2-49.3-170.8-49.3s-161.5,22-170,49.3c-2.6,8.5-5.5,22.2-8.3,37.4 c45.1,46.9,108.5,76,178.7,76s133.6-29.2,178.7-76C424.1,405,421.2,391.2,418.5,382.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D4D6D8"
    },
    points: "247.9,317 208.3,322.3 210.2,335.4 247.8,363.5 286,335.4 287.9,322.3 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8E502E"
    },
    d: "M287,282.1h-77.8c12.1,36.6,1,53.3,1,53.3l26.9,6.1h22l26.9-6.1C286,335.4,274.9,318.7,287,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E7E8"
    },
    d: "M304.2,336.5l-16.4-14.2l-39.7,19.2l-39.8-19.2l-16.2,14.1l-1.6,1.4c0,0,23.9,117.9,45.1,158 c4.2,0.2,8.3,0.3,12.6,0.3c4.2,0,8.4-0.1,12.5-0.3c21.3-40.2,45.1-158,45.1-158L304.2,336.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272728"
    },
    d: "M190.4,337.8l1.6-1.4c-62.3,6.9-21.7,156.2,43.5,159.5C214.3,455.7,190.4,337.8,190.4,337.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272728"
    },
    d: "M304.2,336.5l1.5,1.3c0,0-23.9,117.9-45.1,158C325.8,492.6,366.4,343.4,304.2,336.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C3C3F"
    },
    points: "293.4,327.1 248.1,345.7 202.8,327.1 199.5,329.9 248.1,350.1 296.7,329.9 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9B9B9A"
    },
    cx: 248.1,
    cy: 378.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9B9B9A"
    },
    cx: 248.1,
    cy: 409.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9B9B9A"
    },
    cx: 248.1,
    cy: 440.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9B9B9A"
    },
    cx: 248.1,
    cy: 471.1,
    r: 4.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1E"
    },
    points: "210.6,327.7 210.6,361.9 241.7,351.1 241.7,338.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D1D1E"
    },
    points: "254.5,338.4 254.5,351.1 285.6,361.9 285.6,327.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 336.3,
    style: {
      fill: "#1D1D1E"
    },
    width: 19.3,
    height: 17.2
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B5C32"
    },
    d: "M248.1,61.6c-48.7,0-88.3,21.2-88.3,113.6c0,31.3,6.2,55.8,15.5,74.7c20.4,41.6,55.7,56.1,72.8,56.1 s52.4-14.5,72.8-56.1c9.3-18.9,15.5-43.4,15.5-74.7C336.4,82.8,296.8,61.6,248.1,61.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A1D12"
    },
    d: "M284.1,250.9c0-5.3-15.7-8.1-33.1-8.9c-0.8,0-2.8,1.9-2.9,1.9c-0.2,0-2-2-2.8-1.9 c-17.4,0.8-33.2,3.6-33.2,8.9c0,1.7-1.3,13.7,4.8,10.2c5-6.5,16.2-11.4,28.2-11.9c1,0,2,0.8,3,0.8c1.1,0,2.1-0.8,3.1-0.8 c12,0.5,22.6,4.6,28.1,11.9C285.4,264.7,284.1,252.6,284.1,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A1D12"
    },
    d: "M248.1,59.1c-58,0-88.3,23.7-88.3,116.1l39.8-33.1c0,0,26.5,0,48.5,0s46.2-35.3,46.2-35.3l42.1,68.4 C336.4,82.8,306.1,59.1,248.1,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A1D12"
    },
    d: "M180.1,138.6l-14.6,2.2c-4.2,10.9-5.6,24.4-5.6,37.5c0,0,8.8-1.9,8.8,2.6l2.8,27.6l3.9-1.9 C175,183.6,180.1,138.6,180.1,138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A1D12"
    },
    d: "M330.8,140.8l-14.6-0.4c0,0,5.1,43.2,4.9,66.2l3.9,1.9l2.8-27.6c0-4.5,8.8-2.6,8.8-2.6 C336.5,165.1,335.1,151.7,330.8,140.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#844A2C"
    },
    d: "M259.5,254.8c-3.3-0.5-11.4,2.7-11.4,2.7s-8.3-3.1-11.6-2.7c-5.3,0.8-13.1,4.9-13.1,6.4 c0,2.4,11,8.8,24.7,8.8s24.7-6.5,24.7-8.8C272.8,261.2,264.9,255.5,259.5,254.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A4229"
    },
    d: "M248.1,262.4c-14.6,0-24.7-1.2-24.7-1.2c0,2.4,11,11.5,24.7,11.5c13.7,0,24.7-9.1,24.7-11.5 C272.8,261.2,262.7,262.4,248.1,262.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B5C32"
    },
    d: "M161.4,178c-8.4,1.4-14.9,5.1-10.1,32.9s10.7,29.1,19.1,27.7L161.4,178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9B5C32"
    },
    d: "M334.9,178l-9,60.6c8.4,1.4,14.3,0.1,19.1-27.7C349.7,183.1,343.3,179.5,334.9,178z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlvinho);
export default __webpack_public_path__ + "static/media/Alvinho.d90ddd91164c24bf5defeb75bba1ccfa.svg";
export { ForwardRef as ReactComponent };